import * as React from "react";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { filter } from "@/types/gallery";
import { Categories } from "@/types";
import { useTranslation } from "@/i18n/client";
import { useLocaleCtx } from "@/contexts/locale";
import GradientBorder from "../common/gradient-border";

type SubCategorySelector = {
  category: filter;
  categories: Categories[];
  setSubCategory: React.Dispatch<React.SetStateAction<filter>>;
  subCategory: filter;
};

export function SubCategorySelector({
  category,
  categories,
  setSubCategory,
  subCategory,
}: SubCategorySelector) {
  const selectedCategory = categories.find((cat) => cat.value === category.value);

  const { lang } = useLocaleCtx();
  const { t } = useTranslation(lang, "nominees");

  React.useEffect(() => {
    setSubCategory({
      title: t("allAwards"),
      value: "",
    });
  }, [category, setSubCategory]);

  return (
    <Select
      onValueChange={(value) =>
        setSubCategory({
          title: value === "all" ? t("allAwards") : value,
          value: value === "all" ? "" : value,
        })
      }
      dir={lang == "en" ? "ltr" : "rtl"}
    >
      <SelectTrigger className="w-[200px] rounded-full bg-foreground p-6 backdrop-blur-md sm:w-[240px] lg:py-8">
        <GradientBorder />
        <SelectValue className="ltr:font-opensans" placeholder={t("allAwards")}>
          {subCategory.title}
        </SelectValue>
      </SelectTrigger>
      <SelectContent className="bg-foreground text-secondary opacity-100">
        <SelectGroup>
          <SelectItem className="cursor-pointer ltr:font-opensans" value="all">
            {t("allAwards")}
          </SelectItem>
          {selectedCategory?.subCategories.map((subCategory) => (
            <SelectItem
              className="cursor-pointer ltr:font-opensans"
              key={subCategory}
              value={subCategory}
            >
              {subCategory}
            </SelectItem>
          ))}
        </SelectGroup>
      </SelectContent>
    </Select>
  );
}
